import { Github, Linkedin } from "lucide-react";

const Contact = () => {
  return (
    <section id="contact" className="py-24 relative bg-card/30">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="font-mono text-sm text-primary mb-4">
            {">"} ssh root@contact
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            Get In <span className="text-primary text-glow">Touch</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Ready to strengthen your security posture? Let's discuss how I can
            help identify vulnerabilities before they become breaches.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Terminal-style contact */}
          <div className="cyber-card p-8">
            <div className="flex items-center gap-2 mb-6 text-muted-foreground">
              <div className="w-3 h-3 rounded-full bg-accent" />
              <div className="w-3 h-3 rounded-full bg-yellow-500" />
              <div className="w-3 h-3 rounded-full bg-primary" />
              <span className="ml-2 font-mono text-sm">contact.sh</span>
            </div>

            <div className="font-mono space-y-4">
              <div className="flex items-center gap-2">
                <span className="text-primary">$</span>
                <span className="text-muted-foreground">
                  echo $CONTACT_OPTIONS
                </span>
              </div>

              {/* Contact Options */}
              <div className="grid md:grid-cols-3 gap-4 pl-4 border-l-2 border-primary/30">
                <a
                  href="https://github.com/omaritgis"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-4 bg-muted/50 rounded-lg hover:bg-muted transition-colors group"
                >
                  <Github className="w-5 h-5 text-primary" />
                  <div>
                    <p className="text-sm font-semibold">GitHub</p>
                    <p className="text-xs text-muted-foreground">@omaritgis</p>
                  </div>
                </a>

                <a
                  href="https://linkedin.com/in/omartotangy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-4 bg-muted/50 rounded-lg hover:bg-muted transition-colors group"
                >
                  <Linkedin className="w-5 h-5 text-primary" />
                  <div>
                    <p className="text-sm font-semibold">LinkedIn</p>
                    <p className="text-xs text-muted-foreground">
                      Omar Totangy
                    </p>
                  </div>
                </a>
              </div>

              <div className="flex items-center gap-2 pt-4">
                <span className="text-primary">$</span>
                <span className="text-muted-foreground">
                  Connection established
                </span>
                <span className="text-primary animate-pulse">█</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
